<template>
  <div>
    <Modal v-model="cancelPlatformYmsOrderModal" :title="$t('key1004290')" width="700" :transfer="false" :mask-closable="false"
      @on-visible-change="cancelPlatformYmsOrderChange">
      <div class="flex align-items-start">
        <span>{{ `${configCharacters()}` + $t('key1001071') }}</span>
        <Input v-model.trim="invalidReason" style="width:470px;" type="textarea" :rows="5" :maxlength="200"
          :placeholder="$t('key1004287') + `${configCharacters()}` + $t('key1006028') + `${configCharacters()}` + $t('key1006029')">
        </Input>
      </div>
      <template v-if="cancelPrice === 0">
        <div class="mb15 mt20">
          {{ $t('key1001077') }}
          <span class="distributorThemeColor ml3 mr4">{{ timer }}</span>
          {{ $t('key1001078') }}
          <span class="distributorThemeColor">{{ $t('key1001070') + cancelPrice + ' ' + currencyState }}</span>
          {{ $t('key1001079') }}
        </div>
        <div class="flex align-items-center mb15">
          <span class="distributorThemeColor">{{ $t('key1000233') }}</span>
          <span class="mr40">{{ formatCurrency(originalCost) + ' ' + currencyState + '；' }}</span>
          <span class="redColor">{{ $t('key1000234') }}</span>
          <span>{{ formatCurrency(refundAmount) + ' ' + currencyState }}</span>
        </div>
      </template>
      <template #footer>
        <Button @click="cancelPlatformYmsOrderModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" :disabled="!invalidReason" @click="cancelYmsOrderBtn">{{ $t('key1000111') }}</Button>
      </template>
    </Modal>
    <!--取消定制商品订单弹窗-->
    <cancelCustomizedProductOrdersModal
      ref="cancelCustomizedProductOrders"
      @cancelYmsOrderSuccess="cancelYmsOrderSuccess"
    ></cancelCustomizedProductOrdersModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import cancelCustomizedProductOrdersModal from "@/components/common/cancelCustomizedProductOrdersModal.vue";
import {calculateDiffTime, getOrderLogisticsConsumption} from "@/utils/common";

export default {
  name: 'cancelPlatformYmsOrderModal',
  components: {cancelCustomizedProductOrdersModal},
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      invalidReason: '',
      cancelPlatformYmsOrderModal: false,
      ymsPlatformOrderShippingId: null,
      ymsPlatformOrderId: null,
      cancelPrice: 0,
      timer: null,
      originalCost: 0,
      refundAmount: 0,
    };
  },
  methods: {
    // 初始化数据
    initCancelYmsOrderData(obj, platformOrderDetails) {
      this.invalidReason = '';
      this.ymsPlatformOrderShippingId = obj.ymsPlatformOrderShippingId;
      this.ymsPlatformOrderId = platformOrderDetails.ymsPlatformOrderId;
      let allowInvalid = obj.ymsPackageInfo.allowInvalid;
      this.orderStatusTalg = ((![0, 1, 12].includes(platformOrderDetails.status) && platformOrderDetails.status < 4) ||
        [11, 21].includes(platformOrderDetails.status)) ? false : true;
      let goodsList = obj.goodsList || [];
      let talg = goodsList.some((item) => item.isNeedCustomization === 1);
      if (talg) {
        if(this.orderStatusTalg) {
          if (allowInvalid === 0) {
            this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006134'));
            return false;
          } else {
            let items = {
              ymsPlatformOrderShippingId: obj.ymsPlatformOrderShippingId,
              ymsPlatformOrderId: obj.ymsPlatformOrderId,
            };
            let vals = Object.assign({}, obj.ymsPackageInfo, items);
            this.$refs['cancelCustomizedProductOrders'].initCancelCustomizedProductOrdersData(
              'platformOrderDetailsCancelOrder', vals);
          }
        } else {
          this.cancelPlatformYmsOrderModal = true;
        }
      } else {
        this.cancelPlatformYmsOrderModal = true;
      }
      getOrderLogisticsConsumption(obj.ymsPackageInfo.ymsPackageId).then((data) => {
        if (data) {
          this.cancelPrice = data.cancelPrice || 0;
          this.refundAmount = obj.ymsPackageInfo - data.cancelPrice;
          let trackingNumberTime = obj.ymsPackageInfo.trackingNumberTime || '';
          if (trackingNumberTime) {
            trackingNumberTime = this.$uDate.dealTime(trackingNumberTime, 'fulltime');
            this.timer = calculateDiffTime(trackingNumberTime);
          }
        }
      });
    },
    // 确定按钮
    cancelYmsOrderBtn() {
      let query = {
        orderShippingId: this.ymsPlatformOrderShippingId,
        invalidReason: this.invalidReason,
        ymsPlatformOrderId: this.ymsPlatformOrderId
      };
      this.axios.post(api.post_ymsPlatformOrder_cancelOrderYms, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          this.cancelPlatformYmsOrderModal = false;
          this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000488'));
          this.$emit('updateData', true);
        }
      });
    },
    // 监听弹窗
    cancelPlatformYmsOrderChange(value) {
      if (!value) {
        this.cancelPrice = 0;
        this.originalCost = 0;
        this.refundAmount = 0;
        this.timer = null;
      }
    },
    cancelYmsOrderSuccess() {
      this.$emit('updateData', true);
    }
  }
};
</script>

<style lang="less">

</style>
